<script lang="ts">
  import HubSpotCard from "./HubSpotCard.svelte";
  import AwsSystemCardHost from "./remotes/AwsSystemCardHost.svelte";
  import AceLinkCardHost from "./remotes/AceLinkCardHost.svelte";

  export let aws: {
    totalInAws?: number;
    syncedToSharedDb?: number;
    notSynced?: number;
    conflicts?: number;
    errors?: number;
  } | null = null;
  export let acelink: {
    totalInAcelink?: number;
  } | null = null;
  export let hubspot: {
    totalInHubspot?: number;
    syncedToLocal?: number;
    notSyncedToLocal?: number;
    nonAwsDeals?: number;
    showNonAwsDeals?: boolean;
    apiError?: string;
    error?: string;
  } | null = null;
  export let fullySyncedAcrossSystems: number = 0;
  export let lastSyncTime: string = "";
  export let showHubspotCard: boolean = true;

  // AWS metrics
  $: awsTotal = aws?.totalInAws ?? 0;
  $: awsSynced = aws?.syncedToSharedDb ?? 0;
  $: awsErrors = 0;

  // HubSpot metrics
  $: hsTotal = hubspot?.totalInHubspot ?? 0;
  $: hsSynced = hubspot?.syncedToLocal ?? 0;
  $: hsNonAwsDeals = hubspot?.nonAwsDeals ?? 0;
  $: hsShowNonAwsDeals = hubspot?.showNonAwsDeals ?? false;
  $: hsApiError = hubspot?.apiError ?? hubspot?.error ?? "";

  // Shared DB (AceLink) synced means the record exists in AWS, Acelink, and HubSpot.
  $: sharedDbTotal = acelink?.totalInAcelink ?? 0;
  $: sharedDbSynced = fullySyncedAcrossSystems;
</script>

<div class="min-w-0 rounded-xl border border-white/10 bg-[linear-gradient(135deg,rgba(255,255,255,0.045)_0%,rgba(255,255,255,0.02)_100%)] p-4 shadow-[inset_0_1px_0_rgba(255,255,255,0.035)] sm:p-6 mb-6 w-full">
  <h3 class="text-lg font-bold text-white mb-4 uppercase tracking-wide">
    System Sync Overview
  </h3>
  <div
    class="flex flex-col xl:flex-row xl:flex-nowrap items-stretch w-full min-w-0 gap-3 xl:gap-0"
  >
    <div class="flex-1 min-w-0 xl:min-w-[200px] min-h-[20rem] flex flex-col">
      <AwsSystemCardHost
        totalOpportunities={awsTotal}
        fullySynced={awsSynced}
        errors={awsErrors}
        {lastSyncTime}
      />
    </div>
    <div
      class="flex-shrink-0 xl:w-10 py-1 xl:py-0 flex items-center justify-center text-white"
      aria-hidden="true"
    >
      <span class="text-xl font-bold leading-none select-none xl:hidden">⇅</span>
      <span class="text-xl font-bold leading-none select-none hidden xl:inline">⇄</span>
    </div>
    <div class="flex-1 min-w-0 xl:min-w-[200px] min-h-[20rem] flex flex-col">
      <AceLinkCardHost
        totalOpportunities={sharedDbTotal}
        fullySynced={sharedDbSynced}
        {lastSyncTime}
      />
    </div>
    {#if showHubspotCard}
      <div
        class="flex-shrink-0 xl:w-10 py-1 xl:py-0 flex items-center justify-center text-white"
        aria-hidden="true"
      >
        <span class="text-xl font-bold leading-none select-none xl:hidden">⇅</span>
      <span class="text-xl font-bold leading-none select-none hidden xl:inline">⇄</span>
      </div>
      <div class="flex-1 min-w-0 xl:min-w-[200px] min-h-[20rem] flex flex-col">
        <HubSpotCard
          totalOpportunities={hsTotal}
          fullySynced={hsSynced}
          nonAwsDeals={hsNonAwsDeals}
          showNonAwsDeals={hsShowNonAwsDeals}
          apiError={hsApiError}
          {lastSyncTime}
        />
      </div>
    {/if}
  </div>
</div>
